module.exports = __webpack_public_path__ + "c926073f9aa0a951197600481c8cfcc8.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/itcavantgardestd-bold-webfont.eot
 ** module id = 374
 ** module chunks = 0
 **/